import CustomSearchBar from "components/CustomSearchBar";
import useDebouncedValue from "hooks/useDebouncedValue";
import moment from "moment";
import { useEffect, useState } from "react";
import { Row } from "react-bootstrap";
import ListViewContainer from "components/ListViewContainer";
import { useGetFPOListQuery } from "features/onboarding/organizations/FarmersGroup/FPO/FPOApiSlice";
import LeadStatusTag from "features/onboarding/organizations/LeadStatusTag";

const FpoProjectList = () => {
  const [users, setUsers] = useState([]);

  const [selectedFpo, setSelectedFpo] = useState({});

  const [pagination, setPagination] = useState({ page: 1, pageCount: 0 });
  const [fpoDetails, setFpoDetails] = useState({});
  const [searchKey, setSearchKey] = useState("");

  const debouncedSearch = useDebouncedValue(searchKey);

  const handleChangeSearch = (message) => {
    setSearchKey(message);
  };

  const { data: data, isLoading, refetch } = useGetFPOListQuery({
    pagination,
    searchKey: debouncedSearch || "",
  });

  useEffect(() => {
    const dataFromApi = data?.data?.results
      ? data?.data?.results.filter((item) => item.project !== null)
      : [];
    const paginationFromApi = data?.data?.pages
      ? { page: data?.data?.current_page, pageCount: data?.data?.pages }
      : pagination;

    setUsers(dataFromApi);
    setPagination(paginationFromApi);
  }, [data]);

  const handleCheckboxChange = (event, row) => {
    let updatedSelection;
    setSelectedFpo((prevSelected) => {
      updatedSelection = { ...prevSelected };
      if (event.target.checked) {
        updatedSelection[row.id] = row;
      } else {
        delete updatedSelection[row.id];
      }
      localStorage.setItem(
        "selectedFpo",
        JSON.stringify(updatedSelection || {})
      );
      return updatedSelection;
    });
  };

  const LastSelected = JSON.parse(localStorage.getItem("selectedFpo"));

  useEffect(() => {
    const savedFpo = JSON.parse(localStorage.getItem("selectedFpo")) || {};
    setFpoDetails(savedFpo);
  }, [selectedFpo]);

  const columns = [
    {
      field: "select Fpo",
      headerName: "Select",
      width: 90,
      renderCell: (cellValues) => (
        <div>
          <input
            type="checkbox"
            checked={
              (selectedFpo && !!selectedFpo[cellValues?.row?.id]) ||
              (LastSelected && LastSelected[cellValues?.row?.id])
            }
            onChange={(e) => handleCheckboxChange(e, cellValues.row)}
            className="mx-3 cursor"
          />
        </div>
      ),
    },
    {
      field: "created_at",
      headerName: "Created At",
      width: 120,
      type: "date",
      valueFormatter: (params) => moment(params?.value).format("DD/MM/YYYY "),
    },
    { field: "organization_name", headerName: "Organization", width: 180 },
    { field: "phone_number", headerName: "Phone Number", width: 140 },
    { field: "email", headerName: "Email", width: 180 },
    { field: "registration_number", headerName: "COI Number", width: 150 },
    {
      field: "implementation_agency",
      headerName: "Implementation Agency",
      width: 200,
    },
    { field: "land_holding", headerName: "Land Holding", width: 130 },
    {
      field: "current_status",
      headerName: "Current Status",
      width: 160,
      renderCell: (cellvalues) => {
        return (
          <LeadStatusTag
            statusVal={cellvalues?.row?.current_status.split("_").join(" ")}
          />
        );
      },
    },
  ];
  const tableData = {
    rows: users,
    columns: columns,
    paginationState: [pagination, setPagination],
    isLoading: isLoading,
  };

  return (
    <div className="mt-lg-0 mt-md-0 mt-3">
      <div className="d-lg-block d-md-block d-none">
        <div className="searchboxtable d-flex justify-content-end align-items-center gap-4">
          <div className="">
            Total FPO :
            <span className="text-success">&nbsp;{users?.length}</span>
          </div>

          <CustomSearchBar sendSearchFunction={handleChangeSearch} />
        </div>
      </div>
      <div className="d-lg-none d-md-none d-block mt-1">
        <Row className="searchboxtable d-flex justify-content-end">
          <div className="d-flex justify-content-between align-items-center">
            <CustomSearchBar sendSearchFunction={handleChangeSearch} />
          </div>

          <div className="my-lg-0 my-md-0 my-1">
            {" "}
            Total FPO :
            <span className="text-success">&nbsp;{data?.data?.total}</span>
          </div>
        </Row>
      </div>
      <div className="mt-lg-5 mt-md-3 mt-0">
        <ListViewContainer
          showHeaderSection={true}
          searchBar={true}
          tableData={{
            rows: tableData.rows,
            columns: tableData.columns,
            paginationState: [pagination, setPagination],
            isLoading: tableData.isLoading,
            checkboxShowFalse: true,
          }}
        />
      </div>
    </div>
  );
};

export default FpoProjectList;
